import {
  DO_NOTHING,
  GLOBAL_FAIL,
  HIDE_SPINNER,
  RESET_MESSAGE,
  SHOW_MESSAGE,
  SHOW_SPINNER,
} from '../actionConstants';

export const showMessage = (payload: any) => (dispatch: any) => {
  dispatch({
    type: SHOW_MESSAGE,
    payload: payload,
  });
};

export const resetMessage = (payload: any) => (dispatch: any) => {
  dispatch({
    type: RESET_MESSAGE,
    payload: payload,
  });
};

export const doNothing = (payload: any = {}) => (dispatch: any) => {
  dispatch({
    type: DO_NOTHING,
    payload: payload,
  });
};

export const showSpinner = () => (dispatch: any) => {
  dispatch({
    type: SHOW_SPINNER,
  });
};

export const hideSpinner = () => (dispatch: any) => {
  dispatch({
    type: HIDE_SPINNER,
  });
};

export const globalFail = () => (dispatch: any) => {
  dispatch({
    type: GLOBAL_FAIL,
  });
};
